<app-img-header title="Catálogos" alt="Catálogos" image="/assets/images/catalogos/intro.jpg"> </app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<main class="main" id="catalogs">
  <div id="detail">
    <div class="pageWidth">
      <div class="wrapperG5">
        <div>
          <a href="financial-product/list">Productos</a>
        </div>
        <div>
          <a href="catalogs/brand">Marcas</a>
        </div>
        <div>
          <a href="catalogs/sub-brand">Submarcas</a>
        </div>
        <div>
          <a href="catalogs/plan-piso/list">Plan Piso</a>
        </div>
        @if (!HIDE_DRM_REGION) {
        <div>
          <a href="catalogs/region-drm">Región / DRM</a>
        </div>
        }
        <div>
          <a href="/dealers">Distribuidores</a>
        </div>
        @if (active_client_catalog) {
          <div>
            <a href="/clients">Clientes</a>
          </div>
        }
      </div>
    </div>
  </div>
</main>
